import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import { useMobxStores } from '@stores/store';
import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useWindowSize } from 'usehooks-ts';
import { isMobileWithOutIpad } from '@helpers/EnvHelper';

const SectionCoupon = () => {
  const { i18n, t } = useTranslation();
  const { mediaStore } = useMobxStores();
  const location = useLocation();

  const { width } = useWindowSize();
  let sectionStyle = {};
  let sectionClass = '';

  if (isMobileWithOutIpad() || width < 980) {
    sectionStyle = {
      backgroundImage: 'url(/img/v2/main/mobile/bg/bg_bottom.png)',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
    };

    sectionClass = 'pt-[50%] ';
  } else {
    sectionStyle = {
      backgroundImage: 'url(/img/v2/main/bg/bg_pc_bottom.png)',
      backgroundSize: '100%',
      backgroundRepeat: 'no-repeat',
      backgroundColor: '#e9acdb',
    };
  }

  useEffect(() => {}, []);

  return (
    <section
      className=" text-center py-10 px-[15px] xs:px-[30px] relative min-h-[500px] pt-[20%] overflow-hidden text-center"
      style={sectionStyle}
    >
      <div
        className={`${sectionClass}  p-2 font-extrabold m-auto prose px-20 font-TmoneyRoundWind  text-[#000] #xxxs:text-3xl text-4xl xs:text-5xl md:text-6xl coupon_shadow `}
      >
        {t('쿠폰등록br')}
      </div>
      <p className="text-[#ffffff] pt-10   text-md sm:text-xl md:text-2xl ">
        {t('쿠폰 코드를 가지고 계신가요?')} <br />
        {t('코드를 등록하고 특별 선물 받아가세요!')}
      </p>
      <div className="flex justify-center">
        <img
          src={`/img/v2/main/coupon_${
            ['kr', 'en', 'jp'].includes(i18n.language) ? i18n.language : 'kr'
          }.png`}
          alt="bts coupon"
        />
      </div>
      <a
        href={`/${i18n.language}/coupon`}
        className="mx-[20%] px-5 sm:m-auto max-w-[360px] font-nuniSans text-[#a68df7] flex justify-center items-center  rounded-full text-[#fff] font-bold btn-coupon-style2 text-center py-5 xs:text-2xl"
      >
        {t('쿠폰 등록 하러가기')}
      </a>
    </section>
  );
};

export default observer(SectionCoupon);
